import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'addLeadingZero',
    standalone: false
})
export class AddLeadingZeroPipe implements PipeTransform {

    transform(value: number | string): any {
        value = parseInt(<string>value, 10);

        if (isNaN(value)) {
            return null;
        }

        const isSingleDigit: boolean = value < 10;
        let transformedValue: string | number = null;

        if(isSingleDigit) {

            transformedValue = '0' + value;

            return transformedValue;

        } else {

            return value;

        }
    }

}
